import { render, staticRenderFns } from "./AllergyListPage.vue?vue&type=template&id=e1e25282&scoped=true"
import script from "./AllergyListPage.vue?vue&type=script&lang=js"
export * from "./AllergyListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e25282",
  null
  
)

export default component.exports